import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ConfirmationService, MessageService, Message } from 'primeng/api';
import { BreadcrumbService } from 'src/app/app.breadcrumb.service';
import { FAZILService, User, UserService } from 'src/app/core';
import { UIService } from 'src/app/core/services/ui.service';
import { Invoice } from 'src/app/modelo/Invoice';
import { ComprobantesService } from 'src/app/services/comprobantes.service';
import { environment } from 'src/environments/environment';
import * as moment from 'moment';
import { ServiciosService } from 'src/app/servicios/servicios.service';
import { SubjectCustomer } from '../modelo/SubjectCustomer'
import { Product } from '../modelo/Product';
import { Subject } from '../modelo/Subject';

import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ProductoOutput } from '../core/models/producto.model';

@Component({
    selector: 'app-servicios',
    templateUrl: './servicios.component.html',
    styleUrls: ['./servicios.component.scss']
})
export class ServiciosComponent implements OnInit {

    //Variables de configuración/mensajes
    appConfig = environment.settings;

    errors: Object = {};
    msgs: Message[] = [];

    //Variables con objeto de edición
    currentUser: User;

    servicios: SubjectCustomer[] = [];
    producto: Product = new Product();
    serviciosCustomers: SubjectCustomer[] = [];

    //Variables auxiliares
    cols: any[];
    multiSortMeta = [];
    cargandoDataInit: boolean = false;
    procesando: boolean = false;
    ui: UIService;
    buttonsActions: any[] = [];
    mostrarEditor: boolean = false;

    iva12: boolean = true;


    selectedServicios: any = null;

    listservicio: any[] = [{ name: 'Servicio', key: 'SERVICE' }, { name: 'Producto', key: 'PRODUCT' }];

    //Help Section
    safeSrc: SafeResourceUrl;
    display: boolean;
    pageDescription: string;
    
    search:string = '';
    pageOptions = { page: 0, pageSize: 10, filter: '', orderBy: 'name', order:'ASC'};
    rows:number = 10; //TODO Esto podra salir de una configuracion
    totalRecords:number = 0;
    constructor(
        private router: Router,
        private userService: UserService,
        private fazilService: FAZILService,
        // private comprobantesService: ComprobantesService,
        // private facturasService: FacturasService,
        private serviciosService: ServiciosService,
        private uiService: UIService,
        private confirmationService: ConfirmationService,
        private breadcrumbService: BreadcrumbService,
        private messageService: MessageService,
        private sanitizer: DomSanitizer,
    ) {
        this.ui = uiService;
        moment.locale('es');
        this.cargarDataConstructor();
        
        this.safeSrc =  this.sanitizer.bypassSecurityTrustResourceUrl('https://www.facturafacilecuador.com/ayudas_docs/pdf/ayuda/ayuda_producto.pdf');
        this.pageDescription='En esta sección usted podrá crear sus Productos o Servicios, estos corresponden a los productos o servicios que se van a facturar.';
    }

    cargarDataConstructor() {
        this.cargandoDataInit = false;
        this.breadcrumbService.setItems([{ label: 'Servicios/Productos', routerLink: ['servicios'] }]);
        this.cols = [
            { field: 'name', header: 'Detalle', visible: true },
            { field: 'price', header: 'Precio', visible: true },
            { field: 'taxFactor', header: '% IVA', visible: true },
            { field: 'codigoPrincipal', header: 'Código principal', visible: true },
            { field: 'codigoAuxiliar', header: 'Código auxiliar', visible: false }
        ];
        this.multiSortMeta.push({ field: 'emissionOn', order: -1 });
    }

    ngOnInit(): void {
        this.userService.currentUser.subscribe((userData) => {
            this.currentUser = userData;
            if (this.currentUser && this.currentUser.uuid) {
                this.cargarDataInit();
            }
        });
    }

    async cargarDataInit() {
        const data = await this.serviciosService.getProductosPorOrganizacionDeUsuarioConectadoData(this.pageOptions);
        this.servicios = data['content'];
        this.totalRecords = data['totalElements'];
        this.cargandoDataInit = false;
    }

    presentarOpcionesActionSheet(event, item: SubjectCustomer) {
        this.buttonsActions = [
            {
                text: 'Editar',
                icon: 'pi pi-pencil',
                cssClass: 'p-button-text p-button-info',
                action: 'editar',
                data: item,
                disabled: false
            }, {
                text: 'Eliminar',
                icon: 'pi pi-trash',
                cssClass: 'p-button-text p-button-danger',
                action: 'eliminar',
                data: item,
                disabled: false,
            },
            // {
            //     text: 'Facturar',
            //     icon: 'pi pi-send',
            //     cssClass: 'p-button-text p-button-plain',
            //     action: 'facturar',
            //     data: item,
            //     disabled: false
            // }
        ];
    }

    async ejecutarAccion(event, accion: string, pro: Product) {
        this.ui.limpiarMessages();
        if (accion == 'editar') {
            this.mostrarEditor = true;
            this.producto = pro;
            this.iva12 = this.producto.taxType == '2' && this.producto.taxFactor == this.appConfig.app.iva.factor;

            if (pro.productType == "SERVICE") {
                this.selectedServicios = this.listservicio[0];
            } else {

                this.selectedServicios = this.listservicio[1];
            }
            //            this.code = this.customer.code;
        } else if (accion == 'eliminar') {
            this.eliminarItemConfirm(pro);
        }
    }

    nuevoServicio(): void {
        this.resetVariables();
        this.mostrarEditor = true;
    }

    guardarServicio(form: any): void {

        this.ui.limpiarMessages();
        if (this.iva12) {
            this.producto.taxType = '2'; //TABLA 17. IVA 
            this.producto.taxFactor = this.appConfig.app.iva.factor; 
        } else {
            this.producto.taxType = '2';  //TABLA 17. IVA con porcentaje 0
            this.producto.taxFactor = 0; 
        }
        
        this.producto.productType = this.selectedServicios.key;
        this.producto.photo = null;

        if (this.producto) {
            //Guardar producto en persistencia
            this.serviciosService.enviarProducto(this.producto).subscribe(
                async (data) => {
                    this.producto = data;
                    this.producto.amount = 1;
                    this.mostrarEditor = false;
                    this.cargarDataInit(); //Recargar
                    //this.servicios.push(this.producto); //Agrega a la lista un onjeto SubjectCustomer
                    this.ui.mostrarMensaje("success", "Se registró el servicio/producto con éxito.");
                },
                (err) => {
                    this.ui.mostrarError(err);
                }
            );
        }
    }
    
    eliminarItemConfirm(item: Product) {
        this.confirmationService.confirm({
            message: this.ui.buildMsgConfirm(this.appConfig.properties.defaultActions.execute.delete, item.name),
            accept: () => {
                this.eliminarItem(item);
            },
        });
    }


    async eliminarItem(item: Product) {
        console.log(item);
        this.serviciosService.borrarProducto(item.uuid).subscribe(
            async (data) => {
                await this.cargarDataInit(); //Refrescar la página actual
                this.ui.mostrarMensaje(`${this.appConfig.primeng.severities.execute.success}`,
                    `${this.ui.buildMsgSubscribe(this.appConfig.properties.defaultActions.execute.delete, 'Producto', item.name, false)}`);
            },
            (err) => {
                this.ui.mostrarError(err);
            }
        );
    }

    bindProducto(values: Object) {
        Object.assign(this.producto, values);
    }

    onKey(event: KeyboardEvent) {
        this.ui.limpiarMessages();
    }

    /**
     ** Métodos de formulario
     **/
    resetVariables(): void {
        this.ui.limpiarMessages();
        this.mostrarEditor = false;
        this.iva12 = false;
        this.producto = {} as Product;
    }
    
    async handlePagination(paginationData){
        
        const page = paginationData.page;
        this.pageOptions = { page: page, pageSize: this.rows, filter: this.search, orderBy: 'name', order:'ASC'};
        const data = await this.serviciosService.getProductosPorOrganizacionDeUsuarioConectadoData(this.pageOptions);
        this.servicios = data['content'];
    }
    
    //dt.filterGlobal($event.target.value, 'contains')
    async filteredProductByKeyword(event){
        this.search = event.target.value;
        this.pageOptions = { page: 0, pageSize: this.rows, filter: this.search, orderBy: 'name', order:'ASC'};
        const data = await this.serviciosService.getProductosPorOrganizacionDeUsuarioConectadoData(this.pageOptions);
        this.servicios = data['content'];
        this.totalRecords = data['totalElements'];
    }
    
    handleProductoGuardado(productoOutput:ProductoOutput){
        this.mostrarEditor = false;
    }
}
